import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import { Amplify } from "aws-amplify";
import VueI18n from "vue-i18n";
import Vuetify from "vuetify";
// import { initializeApp } from "firebase/app";
// import { getMessaging, getToken } from "firebase/messaging";

Vue.config.productionTip = false;

Vue.use(VueI18n);
Vue.use(Vuetify);

// const firebaseConfig = {
//   apiKey: "AIzaSyB468gUOeMRWpPwWpnpmf3PV-KrTK-RHRo",

//   authDomain: "nirufcm-notifications.firebaseapp.com",

//   projectId: "nirufcm-notifications",

//   storageBucket: "nirufcm-notifications.appspot.com",

//   messagingSenderId: "134242443625",

//   appId: "1:134242443625:web:3f9120712b320818f15df8",

//   measurementId: "G-B19DCGPLLV",
// };

// const app = initializeApp(firebaseConfig);
// const messaging = getMessaging(app);
// var admin = require("firebase-admin");

// var serviceAccount = require(".json");

// admin.initializeApp({
//   credential: admin.credential.cert(serviceAccount),
// });

// // This registration token comes from the client FCM SDKs.
// const registrationToken =
//   "efm8XVqWVok8rJ8cg80Pbc:APA91bFx4SFICdUTAnVNMPdVzrRKWo67HlEfZUlwrS1buUQ8i_F90tr6sT3CcN5AQjJ58zqFRIexoj29gz7Xg4qAJ1DOs2BvyFEWa_aL3NUe7W5VSQBBZffl-8_Z3oT8I4YQKzYCecJg";

// const message = {
//   notification: {
//     title: "I am Admin",
//     body: "Hi Client",
//   },
//   webpush: {
//     fcmOptions: {
//       link: "/LandingPage",
//     },
//   },

//   token: registrationToken,
// };

// admin
//   .messaging()
//   .send(message)
//   .then((response) => {
//     console.log("Successfully sent message:", response);
//   })
//   .catch((error) => {
//     console.log("Error sending message:", error);
//   });

const messages = {
  en: {
    welcomeMsg: "Sub-categories",
    Source: "Categories",
  },
  es: {
    welcomeMsg: "하위 카테고리",
    Source: "카테고리",
  },
};

const i18n = new VueI18n({
  locale: "en",
  fallbackLocale: "es",
  messages,
});

Amplify.configure({
  Auth: {
    userPoolId: "YOUR_USER_POOL_ID",
    region: "YOUR_REGION",
    userPoolWebClientId: "YOUR_USER_POOL_WEB_CLIENT_ID",
  },
});

new Vue({
  vuetify,
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// document.addEventListener("DOMContentLoaded", function () {
//   Notification.requestPermission().then((permission) => {
//     if (permission === "granted") {
//       getToken(messaging, {
//         vapidKey:
//           "BHxlaE3qmMPUJDP2PEjTesJ76haZw-ox-UT7mz9z7NhUF22Bf_cTMoyA_m0dzuWXgj8YICVSPY6i-dy4uFGFlqQ",
//       })
//         .then((currentToken) => {
//           if (currentToken) {
//             console.log("Token:", currentToken);
//           } else {
//             console.log("No registration token available.");
//           }
//         })
//         .catch((err) => {
//           console.error("An error occurred while retrieving token:", err);
//         });
//     } else {
//       console.log("Notification permission denied");
//     }
//   });
// });
